import React, { useEffect, useRef, useState } from 'react';
import useRegulationDocumentData from 'components/Dashboard/Regulations/useRegulationDocumentData';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import RegulationsDocumentOverviewTab from 'components/Dashboard/Regulations/RegulationsDocumentOverviewTab';
import RegulationsDocumentCommentsTab from 'components/Dashboard/Regulations/RegulationsDocumentCommentsTab';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';

const TAB_HASH = {
  overview: 'overview',
  comments: 'comments',
};

const tabFromHash = () => {
  const key = (typeof window !== 'undefined' ? window.location.hash : '').replace(/^#/, '');
  return TAB_HASH[key] ? key : 'overview';
};

const RegulationDocumentContentPage = ({ currentNew }) => {
  const { comments, commentsTotal, isCommentsLoading, loadRegulationDocumentComments } = useRegulationDocumentData({
    commentsOnly: true,
  });
  const [activeTab, setActiveTab] = useState(tabFromHash);
  const [heightContainer, containerRef] = useHeightContainer();
  const [scrollingOverview, setScrollingOverview] = useState(false);
  const scrollbarRef = useRef(null);

  useEffect(() => {
    const onHashChange = () => setActiveTab(tabFromHash());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const selectTab = (tab) => {
    window.location.hash = TAB_HASH[tab];
  };

  const commentsTitle = `Comments${commentsTotal > 0 ? ` (${commentsTotal})` : ''}`;

  return (
    <>
      <div className='px-3 px-lg-4 pt-4 border-bottom' ref={containerRef}>
        <div className='mb-4'>
          <button
            className={`general-button ${activeTab === 'overview' ? 'action-button' : 'hovered-button'} border rounded-pill px-3 py-1 mr-3`}
            onClick={() => selectTab('overview')}
          >
            Document overview
          </button>
          <button
            className={`general-button ${activeTab === 'comments' ? 'action-button' : 'hovered-button'} border rounded-pill px-3 py-1`}
            onClick={() => selectTab('comments')}
          >
            {commentsTitle}
          </button>
        </div>
      </div>
      {activeTab === 'overview' && !!currentNew && (
        <CustomScrollbar
          className={'simple-scrollbar indented-scrollbar-small'}
          style={{ height: `${heightContainer - 95}px` }}
          minimalThumbYSize={55}
          maximalThumbYSize={100}
          onScrollStart={() => {
            setScrollingOverview(true);
          }}
          onScrollStop={() => {
            setScrollingOverview(false);
          }}
        >
          <RegulationsDocumentOverviewTab
            currentNew={currentNew}
            scrollbarRef={scrollbarRef}
            scrolling={scrollingOverview}
          />
        </CustomScrollbar>
      )}
      {activeTab === 'comments' && (
        <RegulationsDocumentCommentsTab
          comments={comments}
          commentsTotal={commentsTotal}
          isLoading={isCommentsLoading}
          loadRegulationDocumentComments={loadRegulationDocumentComments}
          heightContainer={heightContainer}
        />
      )}
    </>
  );
};

export default RegulationDocumentContentPage;
